import type { FundDetail } from "@/data/fund-detail-types";
import { useEffect, useState } from "react";
import { createPortal } from "react-dom";

export function BufferRiskStrip({ fund }: { fund: FundDetail }) {
  const text =
    fund.riskStripText ||
    "Buffer ETFs use FLEX Options to seek structured outcomes over a specific period. The cap and buffer are set at the start of each outcome period and may vary. Outcomes are designed for investors who hold for the full period. These products may not be suitable for all investors. Review the prospectus before investing.";

  // Mount the strip ABOVE the layout's nav via the etf-pre-nav-slot portal
  // target, if the layout provides one. When absent (the chrome layout in
  // this replica does not render the slot) the strip simply renders nothing.
  const [slot, setSlot] = useState<HTMLElement | null>(null);
  useEffect(() => {
    setSlot(document.getElementById("etf-pre-nav-slot"));
  }, []);

  const node = (
    <div
      className="m-0 px-10 max-[640px]:px-4 py-2.5 rounded-none border-b border-[var(--etf-orange)] bg-[var(--etf-orange)] flex items-start gap-3 max-[640px]:gap-2.5 animate-[fadeIn_0.5s_ease_0.05s_both]"
      role="note"
    >
      <svg
        className="shrink-0 w-[18px] h-[18px] mt-px text-white opacity-95"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={1.75}
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
        focusable="false"
      >
        <circle cx="12" cy="12" r="10" />
        <line x1="12" y1="16" x2="12" y2="12" />
        <line x1="12" y1="8" x2="12.01" y2="8" />
      </svg>
      <div className="flex-1 min-w-0">
        <p className="font-[family-name:var(--font-geist)] text-[12.5px] leading-[1.55] font-medium tracking-[0.02em] text-white m-0">
          {text}
        </p>
      </div>
    </div>
  );

  return slot ? createPortal(node, slot) : null;
}
